import { Injectable } from '@angular/core';

import { ApiService } from '../../../shared/api/api.service';
import { ApiCacheOptions } from '../../../shared/api/api-cache-options.model';
import { PagedResult } from '../../../shared/model/generic-paged-result.model';
import { NameVal } from '../../../shared/model/name-val.model';
import { ArcSearch } from './arc-search.model';
import { ArcFormula } from './arc-formula.model';

@Injectable()
export class ArcService {
  private _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;

    //this._cacheOptions = new ApiCacheOptions();
    //this._cacheOptions.DisableCaching = true;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  public searchArcs(params: ArcSearch = new ArcSearch()): Promise<PagedResult<Array<ArcFormula>>> {
    return this._apiService.getPaged('AutoRevCalcs', params, this._cacheOptions);
  }

  public getArc(arcId: number): Promise<ArcFormula> {
    return this._apiService.get('AutoRevCalc/' + arcId.toString(), this._cacheOptions);
  }

  public deleteArc(arcId: number): Promise<void> {
    return this._apiService.delete('AutoRevCalc/' + arcId.toString());
  }

  public createArc(arc: ArcFormula): Promise<number> {
    return this._apiService.post('AutoRevCalc', arc);
  }

  public updateArc(arc: ArcFormula): Promise<void> {
    return this._apiService.put('AutoRevCalc/' + arc.ArcID.toString(), arc);
  }

  public getArcBuilderFieldList(): Promise<Array<NameVal>> {
    return this._apiService.get('AutoRevCalc/ArcBuilderFieldList');
  }
}
